import { useState } from 'react';
import { OrderLineChart } from './OrderLineChart';
import { OrderGroupedBarChart } from './OrderGroupedBarChart';
 import { Box, Grid, Typography, TextField, MenuItem } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

// Register all required Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement, // Required for Line Chart
  LineElement, // Required for Line Chart
  Tooltip,
  Legend
);

export const OrderDashbordDay = ({ data }) => {
  const [statusFilter, setStatusFilter] = useState('all');

  // Filter data based on selected status
  const filteredData = statusFilter === 'all'
    ? data
    : data.filter(item => item.status === statusFilter);

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
      <Typography variant="h6" gutterBottom>
        Daily Order Analytics Dashboard 
      </Typography>

      {/* Status Filter Dropdown */}
      <TextField
        select
        label="Filter by Status"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        sx={{ mb: 3, width: 200 }}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="processing">Processing</MenuItem>
        <MenuItem value="received">Received</MenuItem>
        <MenuItem value="rejected">Rejected</MenuItem>
      </TextField>

      {/* Charts Grid */}
      <Grid container spacing={3}>
        
        <Grid item xs={12} md={6}>
          <OrderGroupedBarChart data={filteredData} />
        </Grid>
        <Grid item xs={12} md={6}>
          <OrderLineChart data={filteredData} />
        </Grid>
      </Grid>
    </Box>
  );
};